module.exports = __webpack_public_path__ + "static/media/01.529ee003.jpg";